export const GET_ERRORS = 'GET_ERRORS';
export const GET_LOAD_DATA_ERRORS = 'GET_LOAD_DATA_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const PIN_SEND = 'PIN_SEND';
export const PIN_VERIFY = 'PIN_VERIFY';
export const LOGOUT = 'LOGOUT';

// Subscriptions
export const GET_DATA = 'GET_DATA';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const HIDE_LOADING_SPINNER = 'HIDE_LOADING_SPINNER';
export const GET_TOTAL_PAGE_SIZE = 'GET_TOTAL_PAGE_SIZE';
export const GET_AUTOSUGGEST_DATA = 'GET_AUTOSUGGEST_DATA';
export const GET_UNIQUE_DATA = 'GET_UNIQUE_DATA';
export const UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_FAIL = 'UNSUBSCRIBE_FAIL';
export const UNSUBSCRIBE_CANCEL = 'UNSUBSCRIBE_CANCEL';
export const GET_VERIFIED_SUBSCRIBER_SUCCESS = 'GET_VERIFIED_SUBSCRIBER_SUCCESS';
export const GET_VERIFIED_SUBSCRIBER_FAILED = 'GET_VERIFIED_SUBSCRIBER_FAILED';
export const CONFIRM_UNSUBSCRIBE_SUCCESS = 'CONFIRM_UNSUBSCRIBE_SUCCESS';
export const CONFIRM_UNSUBSCRIBE_FAILED = 'CONFIRM_UNSUBSCRIBE_FAILED';

export const ERROR_MSG = 'ERROR';
export const DATA_ERROR_MSG = 'Data Load Error';
export const SUCCESS_MSG = 'SUCCESS';
export const INVALID_PIN = 'Invalid Pin';
export const CHANGE_THEME = 'CHANGE_THEME';
